import React from 'react';
import styled from '@emotion/styled';

const Loader = styled.div`
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border-radius: 50%;
  background:
    linear-gradient(0deg, rgb(255 255 255 / 50%) 26%, transparent 0 74%, rgb(255 255 255 / 100%) 0) 50% / 8% 100%,
    linear-gradient(90deg, rgb(255 255 255 / 25%) 26%, transparent 0 74%, rgb(255 255 255 / 75%) 0) 50% / 100% 8%;
  background-repeat: no-repeat;
  animation: l23 1s infinite steps(12);

  &::before,
  &::after {
    content: '';
    grid-area: 1/1;
    border-radius: 50%;
    background: inherit;
    opacity: 0.915;
    transform: rotate(30deg);
  }

  &::after {
    opacity: 0.83;
    transform: rotate(60deg);
  }

  @keyframes l23 {
    100% {
      transform: rotate(1turn);
    }
  }
`;

interface ClassicSpinnerProps {
  size?: number;
}

/** Custom replacement for react-spinners-kit's ClassicSpinner, using a layered rotating gradient animation. */
const ClassicSpinner = ({ size = 50 }: ClassicSpinnerProps) => {
  return <Loader style={{ width: `${size}px` }} />;
};

export default ClassicSpinner;
